"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.IconButton = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _IconButton = require("./IconButton.styles");

var _Icon = require("../icon/Icon");

var _classnames = _interopRequireDefault(require("classnames"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

const IconButton = ({
  icon,
  type,
  iconSize,
  ...rest
}) => {
  const Icon = _Icon.Icons[icon];
  return /*#__PURE__*/_react.default.createElement(_IconButton.StyledIconButton, _extends({
    className: (0, _classnames.default)({
      [type]: type
    })
  }, rest), Icon && /*#__PURE__*/_react.default.createElement(Icon, {
    className: "icon left-icon",
    size: iconSize
  }));
};

exports.IconButton = IconButton;
IconButton.defaultProps = {
  disabled: false,
  isRounded: false,
  buttonSize: '40px',
  type: 'primary',
  iconSize: 16
};
IconButton.propTypes = {
  /** Button Text*/
  text: _propTypes.default.string,

  /** Function Callback*/
  onClick: _propTypes.default.func.isRequired,

  /** By Default isisRoundIcon=true, default is false*/
  isRounded: _propTypes.default.bool,

  /** Icon 'Add, Edit, Close, DownArrow', default null*/
  icon: _propTypes.default.string,

  /** Icon position 'left' and 'right', default undefined */
  iconPosition: _propTypes.default.string,

  /** Icon Size, 10, 12, 16 , 18 and 24 */
  iconSize: _propTypes.default.number,

  /** Button size */
  buttonSize: _propTypes.default.string,

  /** Button type. default primary */
  type: _propTypes.default.string
};